module.exports = __webpack_public_path__ + "img/eye.03468393.svg";